import { type PropsWithChildren, useState } from 'react';

import { createStore } from 'zustand';

import type { MergePurgeStore } from './types/merge-purge-store.type';

import { MergePurgeContext } from './merge-purge.context';

export const MergePurgeProvider = ({ children }: PropsWithChildren) => {
  const [store] = useState(() => {
    return createStore<MergePurgeStore>((set, get) => {
      return {
        getGridApi: (view) => {
          return get().gridApi[view];
        },
        gridApi: {},
        isNthCalculatorOpen: false,
        reports: [
          { name: 'Split', view: 'splitinfo' },
          { name: 'Quality Certificate', view: 'certificate' },
          { name: 'QC Processing Summary', view: 'processsummary' },
          { name: 'Summary', view: 'summary' },
          { name: 'Suppression Details', view: 'suppressionDetail' },
          { name: 'Suppression Files', view: 'suppressionFile' },
          { name: 'Seed Count', view: 'seedCount' },
          { name: 'Modeling By List', view: 'modelingByList' },
          { name: 'Twentile Count', view: 'twentileCount' },
          { name: 'Multis By List', view: 'multisByList' },
          { name: 'Multis By Group', view: 'multisByGroup' },
          { name: 'Multis Breakdown', view: 'multisBreakdown' },
          { name: 'State Distribution', view: 'stateDistribution' },
          { name: 'List Company Billing', view: 'listCompanyBilling' },
          { name: 'General terms & conditions', view: 'toc' },
          { name: 'Full Report', view: 'full-report' },
        ],
        setGridApi: (view, api) => {
          set((state) => {
            return {
              ...state,
              gridApi: {
                ...state.gridApi,
                [view]: api,
              },
            };
          });
        },
        setIsNthCalculatorOpen: (isOpen) => {
          set((state) => {
            return {
              ...state,
              isNthCalculatorOpen: isOpen,
            };
          });
        },
      };
    });
  });

  return <MergePurgeContext.Provider value={store}>{children}</MergePurgeContext.Provider>;
};
